export default __webpack_public_path__ + "static/media/36I-102637_-15569_0.9186adac.jpg";